import { connect } from 'react-redux'
import { State } from 'interfaces/state'
import ErrorPage, { ErrorPageStateProps, ErrorPageDispatchProps } from 'components/features/pfm/ErrorPage/ErrorPage'
import { isAuthenticatedSelector, errorTypeSelector, currentUrlSelector } from 'selectors/globalSelectors'
import { logOutActionCreator } from 'actions/authActions'
import { HOMEPAGE_URL } from 'tangle-shared'
import { withRouter, RouteComponentProps } from 'react-router-dom'
import { reloadActionCreator } from 'actions/navigationActions'
import { IS_STATUS_APP } from 'helpers/userAgentHelpers'
import { resetFinancialStateActionCreator } from 'actions/globalActions'

type ErrorPageContainerOwnProps = RouteComponentProps<{}>

const mapStateToProps = (state: State, ownProps: ErrorPageContainerOwnProps): ErrorPageStateProps => ({
  isAuthorized: Boolean(isAuthenticatedSelector(state)),
  errorType: errorTypeSelector(state, ownProps) || 'page-not-found',
  internalError: state.app.error ? state.app.error.internalError : undefined,
  url: currentUrlSelector(state, ownProps),
})

const mapDispatchToProps: ErrorPageDispatchProps = {
  onLogOut: () => logOutActionCreator({ to: HOMEPAGE_URL }),
  onReload: (url?: string) => {
    if (!IS_STATUS_APP) {
      if (url) {
        window.location.href = url
      } else {
        window.location.reload()
      }
    }
    return reloadActionCreator(url)
  },
  onUpdate: resetFinancialStateActionCreator,
}

const ErrorPageContainerInner = connect<ErrorPageStateProps, ErrorPageDispatchProps, ErrorPageContainerOwnProps>(
  mapStateToProps, mapDispatchToProps
)(ErrorPage)
const ErrorPageContainer = withRouter(ErrorPageContainerInner)

export default ErrorPageContainer
